export const NO = '№'
